"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ui = require("@unite-us/ui");
var _getFileIconByContentType = _interopRequireDefault(require("./utils/getFileIconByContentType"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var FileThumbnail = function FileThumbnail(props) {
  var id = props.id,
    className = props.className,
    color = props.color,
    contentType = props.contentType,
    onThumbnailClick = props.onThumbnailClick,
    size = props.size,
    style = props.style;
  var icon = (0, _getFileIconByContentType["default"])(contentType);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "ui-file-thumbnail ".concat(className)
  }, onThumbnailClick ? /*#__PURE__*/_react["default"].createElement("a", {
    id: id,
    onClick: onThumbnailClick,
    role: "button",
    tabIndex: 0
  }, /*#__PURE__*/_react["default"].createElement(_ui.Icon, {
    color: color,
    icon: icon,
    size: size,
    style: style
  })) : /*#__PURE__*/_react["default"].createElement(_ui.Icon, {
    color: color,
    icon: icon,
    size: size,
    style: style
  }));
};
FileThumbnail.propTypes = {
  /** id for reference */
  id: _propTypes["default"].string,
  /** className for reference */
  className: _propTypes["default"].string,
  /** Color of icon */
  color: _propTypes["default"].string,
  /** Type of file (i.e.: `'image/png'`) */
  contentType: _propTypes["default"].string.isRequired,
  /** clickable functionality. */
  onThumbnailClick: _propTypes["default"].func,
  /** Size of FileThumbnail Icon */
  size: _propTypes["default"].number,
  /** Override the inline-styles of the FileThumbnail Icon || **Not Recommended** */
  style: _propTypes["default"].object
};
FileThumbnail.defaultProps = {
  id: '',
  className: '',
  color: '',
  contentType: '',
  onThumbnailClick: null,
  size: 60,
  style: {}
};
var _default = exports["default"] = FileThumbnail;